import Badge from '@anm/components/Badge';
import { media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

type PlayerContainerProps = {
  width?: number;
  height?: number;
  isPasswordScreen?: boolean;
};

const getPlayerSizes = ({ width, height, isPasswordScreen: isPassword }: PlayerContainerProps) => {
  const videoWidth = isPassword ? '400px' : width ? `${width}px` : 'auto';
  const videoHeight = isPassword ? '400px' : height ? `${height}px` : 'auto';

  return css`
    width: ${videoWidth};
    height: ${videoHeight};
  `;
};

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;

  & > div {
    display: flex;
    width: 100%;
    background: var(--blue_100);
    position: relative;
  }
`;

const playerContainerResponsive = media.tablet<PlayerContainerProps>`
  margin-bottom: 20px;
  width: ${({ isPasswordScreen }) => (isPasswordScreen ? '320px' : 'auto')};
  height: ${({ isPasswordScreen }) => (isPasswordScreen ? '320px' : 'auto')};
`;

export const playerContainerCommonStyles = css`
  margin: 0 auto 30px;
  max-width: 100%;
  position: relative;
  ${playerContainerResponsive};
`;

export const PlayerContainer = styled.div<PlayerContainerProps>`
  ${playerContainerCommonStyles};
  ${props => getPlayerSizes(props)};
`;

export const NoVideoBadge = styled(Badge)`
  background: #ffffff;
  box-shadow: 0px 5px 20px rgba(1, 83, 130, 0.2);
  border-radius: 5px;
  display: flex;
  position: absolute;
  cursor: default;
  top: 24px;
  padding: 16px 15px;
  z-index: 2;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  height: auto;
  max-width: 345px;
  text-align: left;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 14px;
  line-height: 22px;
  color: #292a2b;

  &:before {
    width: 30px;
    height: 30px;
    margin-right: 13px;
    flex-shrink: 0;
  }

  span {
    display: block;
  }
`;
